import {
  isDefined,
  isNotEmpty,
  type DashboardFilter,
  type DashboardWidget,
  type ReportKpiInput,
  type TeamId,
  type UserId,
} from '@terros/common'

export function getEffectiveWidgetFilter(
  widget: DashboardWidget,
  dashboardFilter: DashboardFilter | undefined
): DashboardFilter | undefined {
  return widget.filter ?? dashboardFilter
}

export function toDashboardReportFilter({
  dateFilter,
  dashboardFilter,
  currentUserId,
  currentTeamId,
}: {
  dateFilter: ReportKpiInput['filter']
  dashboardFilter: DashboardFilter | undefined
  currentUserId: UserId | undefined
  currentTeamId: TeamId | undefined
}): ReportKpiInput['filter'] {
  const scopeFilter = toScopeReportFilter({ dashboardFilter, currentUserId, currentTeamId })
  if (isDefined(dateFilter) && isDefined(scopeFilter)) return { ...dateFilter, ...scopeFilter }
  return dateFilter ?? scopeFilter
}

function toScopeReportFilter({
  dashboardFilter,
  currentUserId,
  currentTeamId,
}: {
  dashboardFilter: DashboardFilter | undefined
  currentUserId: UserId | undefined
  currentTeamId: TeamId | undefined
}): ReportKpiInput['filter'] {
  if (!dashboardFilter) return undefined

  switch (dashboardFilter.type) {
    case 'current_user':
      if (!currentUserId) return undefined
      return { users: [currentUserId] }
    case 'current_team':
      if (!currentTeamId) return undefined
      return { teams: [currentTeamId] }
    case 'fixed': {
      const { roles, teams, users } = dashboardFilter.filter
      return {
        ...(isNotEmpty(roles) ? { roles } : {}),
        ...(isNotEmpty(teams) ? { teams } : {}),
        ...(isNotEmpty(users) ? { users } : {}),
      }
    }
  }
}
